import { S, ui } from "../../app/store.js";
import { can } from "../../services/access.js";
import { esc } from "../../domain/format.js";
import { today } from "../../domain/dates.js";
import {
  request,
  loadWorkspace,
  importWorkspace,
  waitForWorkspaceSave,
} from "../../services/api.js";
import { render } from "../../app/shell.js";
export function accountActivationForm() {
  if (!can("admin.users")) return "";
  const eligible = S.users.filter(
    (user) =>
      !user.signInEnabled &&
      user.status !== "SUSPENDED" &&
      (!user.expires || user.expires >= today()),
  );
  return `<section class="panel"><div class="panel-h"><div><h2>Invite A User</h2><span class="muted">Send a secure setup link to the user’s work email.</span></div></div>${eligible.length ? `<form id="activate-account" class="work-log-form account-activation-form"><p class="small muted">The user chooses their own password and connects their authenticator. Add their profile before sending an invitation.</p><label>User<select name="businessId" required>${eligible.map((user) => `<option value="${user.id}"${ui.activationUser === user.id ? " selected" : ""}>${esc(user.name)} · ${esc(user.email)}</option>`).join("")}</select></label><button class="pri" type="submit"${ui.inviteBusy ? " disabled" : ""}>${ui.inviteBusy ? "Sending…" : "Send Invitation"}</button></form>` : `<p class="muted">All eligible users already have sign-in accounts. Add a user profile to invite someone else.</p>`}<p class="${ui.toolsError ? "err" : "muted"}" role="status">${esc(ui.toolsMessage || "")}</p></section>`;
}
export function workspaceTools() {
  return `<section class="panel"><h2>Workspace Tools</h2><div class="grid">${can("sys.admin") ? `<section class="work-log-form"><h3>Backups</h3><p class="small muted">Save a complete database export on this computer.</p><button data-workspace-backup>Create Backup</button></section>` : ""}${["OWNER", "SUPER"].includes(S.users.find((user) => user.id === ui.user)?.role) ? `<section class="work-log-form"><h3>Import Existing Milltech Data</h3><p class="small muted">Choose a JSON workspace export. A backup and database revision are kept before import.</p><input id="workspace-import" type="file" accept="application/json,.json" aria-label="Milltech JSON export"></section>` : ""}</div><p class="${ui.toolsError ? "err" : "muted"}" role="status">${esc(ui.toolsMessage || "")}</p></section>`;
}
export async function sendUserInvitation(businessId) {
  if (!can("admin.users") || ui.inviteBusy) return false;
  businessId = String(businessId || "");
  const user = S.users.find((entry) => entry.id === businessId);
  if (
    !user ||
    user.signInEnabled ||
    user.status === "SUSPENDED" ||
    (user.expires && user.expires < today())
  ) {
    ui.toolsError = true;
    ui.toolsMessage = "Choose a user who is eligible for an invitation.";
    render();
    return false;
  }
  ui.activationUser = businessId;
  ui.inviteBusy = true;
  ui.toolsError = false;
  ui.toolsMessage = "";
  for (const button of document.querySelectorAll(
    '#activate-account button[type="submit"], [data-act="u-resend"]',
  )) {
    button.disabled = true;
    if (button.closest("#activate-account") || button.dataset.id === businessId)
      button.textContent = "Sending…";
  }
  const selector = document.querySelector(
    '#activate-account select[name="businessId"]',
  );
  if (selector) selector.disabled = true;
  let sent = false;
  try {
    await waitForWorkspaceSave();
    await request(`/api/accounts/${encodeURIComponent(businessId)}/invite`, {
      method: "POST",
      body: "{}",
    });
    sent = true;
    await loadWorkspace();
    ui.toolsError = false;
    ui.toolsMessage = `Invitation email sent to ${user.email}. They can use the link to create their password.`;
  } catch (error) {
    ui.toolsError = true;
    ui.toolsMessage = sent
      ? "Invitation email sent. Refresh the workspace to update its status."
      : error.message;
  } finally {
    ui.inviteBusy = false;
    render();
  }
  return sent;
}

export function installWorkspaceTools() {
  document.addEventListener("submit", async (event) => {
    if (event.target.id !== "activate-account") return;
    event.preventDefault();
    const businessId = String(
      new FormData(event.target).get("businessId") || "",
    );
    await sendUserInvitation(businessId);
  });
  document.addEventListener("click", async (event) => {
    if (!event.target.closest("[data-workspace-backup]")) return;
    try {
      const result = await request("/api/backup", {
        method: "POST",
        body: "{}",
      });
      ui.toolsError = false;
      await loadWorkspace();
      ui.toolsMessage = "Backup created: " + result.file;
    } catch (e) {
      ui.toolsError = true;
      ui.toolsMessage = e.message;
    }
    render();
  });
  document.addEventListener("change", async (event) => {
    if (event.target.id !== "workspace-import" || !event.target.files[0])
      return;
    try {
      const state = JSON.parse(await event.target.files[0].text());
      await importWorkspace(state.state || state);
      ui.toolsError = false;
      ui.toolsMessage =
        "Workspace imported. Your previous database revision was retained.";
    } catch (e) {
      ui.toolsError = true;
      ui.toolsMessage = e.message;
    }
    render();
  });
}
